/**
 * Shared local-dev port map for wrangler-edits workers.
 * Used by js/config.js (browser) and scripts/dev-worker.mjs (Node).
 */
export const LOCAL_WORKER_REGISTRY = {
  hangout: {
    port: 8787,
    remoteUrl: 'https://hangout.kissandra.ai',
    supportsDevLogs: true,
  },
  'image-producer': {
    port: 8788,
    remoteUrl: 'https://image-producer.kissandra.ai',
  },
  'replicate-image-generator': {
    port: 8789,
    remoteUrl: 'https://image-request.kissandra.ai',
  },
  'data-fetching': {
    port: 8790,
    remoteUrl: 'https://data-fetching.kissandra.ai',
  },
  'create-worker': {
    port: 8791,
    remoteUrl: 'https://create.kissandra.ai',
  },
  'create-sprite-worker': {
    port: 8792,
    remoteUrl: 'https://create-sprite.kissandra.ai',
  },
  'user-worker': {
    port: 8793,
    remoteUrl: 'https://user.kissandra.ai',
  },
  'kssdra-backend': {
    port: 8794,
    remoteUrl: 'https://api.kissandra.ai',
  },
  'stripe-customer': {
    port: 8795,
    remoteUrl: 'https://stripe-customer.kissandra.ai',
  },
  'billing-nsfw': {
    port: 8798,
    remoteUrl: 'https://billing-nsfw.kissandra.ai',
  },
  stt: {
    port: 8796,
    remoteUrl: 'https://stt.kissandra.ai',
  },
  observability: {
    port: 8797,
    remoteUrl: 'https://obs.kissandra.ai',
  },
  'auto-populate-json': {
    port: 8799,
    remoteUrl: 'https://auto-populate-json.customer-kissandraai.workers.dev',
  },
};

export const LOCAL_WORKER_STORAGE_KEY = 'kissandra_use_local_workers';

export const getRegistryMaxPort = () =>
  Math.max(...Object.values(LOCAL_WORKER_REGISTRY).map((entry) => entry.port));

export const getLocalWorkerUrl = (folderName) => {
  const entry = LOCAL_WORKER_REGISTRY[folderName];
  if (!entry) return null;
  return `http://127.0.0.1:${entry.port}`;
};
